var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":_vm.model.title,"footer-hide":"","width":"700"},on:{"on-cancel":_vm.closeModel},model:{value:(_vm.model.show),callback:function ($$v) {_vm.$set(_vm.model, "show", $$v)},expression:"model.show"}},[(_vm.model.show)?_c('div',[_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }